export default "__VITE_ASSET__Cv21Q3f7__"